import './check.css';
export default {
  "check": "pf-v6-c-check",
  "checkBody": "pf-v6-c-check__body",
  "checkDescription": "pf-v6-c-check__description",
  "checkInput": "pf-v6-c-check__input",
  "checkLabel": "pf-v6-c-check__label",
  "checkLabelRequired": "pf-v6-c-check__label-required",
  "modifiers": {
    "standalone": "pf-m-standalone",
    "disabled": "pf-m-disabled"
  }
};